import { render, staticRenderFns } from "./SubscriptionsTab.vue?vue&type=template&id=524880bc"
import script from "./SubscriptionsTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionsTab.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsTab.vue?vue&type=style&index=0&id=524880bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports